import { render, staticRenderFns } from "./dialog-price.vue?vue&type=template&id=182ba090&scoped=true&"
import script from "./dialog-price.vue?vue&type=script&lang=js&"
export * from "./dialog-price.vue?vue&type=script&lang=js&"
import style0 from "./dialog-price.vue?vue&type=style&index=0&id=182ba090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ba090",
  null
  
)

export default component.exports